import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { OffresComponent } from './pages/offres/offres.component';
import { ContactComponent } from './pages/contact/contact.component';
import { AProposComponent } from './pages/a-propos/a-propos.component';
import { ConditionsGeneralesComponent } from './pages/conditions-generales/conditions-generales.component';
import { ConditionsUtilisationComponent } from './pages/conditions-utilisation/conditions-utilisation.component';
import { SeConnecterComponent } from './pages/se-connecter/se-connecter.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { PolitiqueConfidentialiteComponent } from './pages/politique-confidentialite/politique-confidentialite.component';
import { authGuard } from './guards/auth.guard'; // ← ajout ici

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'offres', component: OffresComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'a-propos', component: AProposComponent },
  { path: 'conditions-generales', component: ConditionsGeneralesComponent },
  { path: 'conditions-utilisation', component: ConditionsUtilisationComponent },
  { path: 'se-connecter', component: SeConnecterComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] }, // ← protection ajoutée
  { path: 'politique-confidentialite', component: PolitiqueConfidentialiteComponent },
];
